import { render, staticRenderFns } from "./systemRole.vue?vue&type=template&id=a6e6ea28&scoped=true"
import script from "./systemRole.vue?vue&type=script&lang=js"
export * from "./systemRole.vue?vue&type=script&lang=js"
import style0 from "./systemRole.vue?vue&type=style&index=0&id=a6e6ea28&prod&scoped=true&lang=css"
import style1 from "./systemRole.vue?vue&type=style&index=1&id=a6e6ea28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e6ea28",
  null
  
)

export default component.exports